import React from 'react'
import Subscription from '../../components/User/Subscription';

const FundraiserSubscription = () => {
  return (
    <Subscription />
  )
}

export default FundraiserSubscription;